import App from 'app/app.js';
import Message from 'app/store/Message.js';
import { Severity } from 'app/components/core/severity/severity.config';
import 'app/action/MessageChangeAction.js';
import 'app/action/ResetJobAction.js';

function MessageStore($filter, MessageChangeAction, ResetJobAction, $rootScope, GrowlerService) {
  this.messages = [];
  this.toasterMessage = '';

  this.createMessageOptions = function (scope, messageKey, messageParams, messageType, category) {
    return {
      scope: scope,
      messageKey: messageKey,
      messageParams: messageParams,
      type: messageType,
      category: category
    };
  };

  this.createSystem = function (messageKey, messageParams, messageType) {
    this.create(this.createMessageOptions('system', messageKey, messageParams, messageType));
  };

  this.createForm = function (messageKey, messageParams, messageType, category) {
    this.create(this.createMessageOptions('form', messageKey, messageParams, messageType, category));
  };

  this.create = function (options) {
    var msg = Message.create(options);
    // TODO: move the translation out of the message store and into a directive
    if (msg.messageKey && !msg.message) {
      msg.message = $filter('ltTranslateFilter')(msg.messageKey, msg.messageParams || {});
    }
    this.messages.push(msg);
    MessageChangeAction.dispatch(msg);
  };

  this.clear = function () {
    // faster way of emptying the array compare to setting the length to 0 without creating new array
    while (this.messages.length) {
      this.messages.pop();
    }
  };

  this.removeErrorByIndex = function (index) {
    this.messages.splice(index, 1);
  };

  this.getMessagesByScope = function (scope) {
    return R.filter(R.propEq('scope', scope))(this.messages);
  };

  this.getSystemMessages = function () {
    return this.getMessagesByScope('system');
  };

  this.getFormMessages = function (category) {
    if (category !== undefined) {
      return R.filter(R.propEq('category', category))(this.getMessagesByScope('form'));
    }
    return this.getMessagesByScope('form');
  };

  this.createSelectionTemplateMessage = function (validation) {
    var msg = Message.create({ scope: 'form' });
    msg.message = validation.msg;
    this.messages.push(msg);
    MessageChangeAction.dispatch(msg);
  };

  $rootScope.$on(
    '$locationChangeSuccess',
    function () {
      this.clear();
    }.bind(this)
  );

  this.createGrowler = function (messageKey, messageParams, messageType, options) {
    const opts = options ?? {};
    const message = opts.message || $filter('ltTranslateFilter')(messageKey, messageParams);
    const type = (messageType || '').toUpperCase();
    const severity = Severity[type] || Severity.INFO;

    GrowlerService[severity]({
      title: opts.title ?? '',
      message,
      items: opts.items ?? [],
      closeable: true
    });
  };

  this.popGrowler = function (options) {
    const validKey = options.messageKeys.find((key) => $filter('ltTranslateFilter')(key, {}));
    this.createGrowler(validKey, options.messageParams, options.messageType);
  };

  this.dismissGrowler = function () {
    GrowlerService.dismiss();
  };
}

App.service('MessageStore', [
  '$filter',
  'MessageChangeAction',
  'ResetJobAction',
  '$rootScope',
  'GrowlerService',
  MessageStore
]);
